import React from "react";
const TableFillerColumn = () => React.createElement(React.Fragment, null);
TableFillerColumn.displayName = "TableFillerColumn";
export const isTableFillerType = (type) => type === TableFillerColumn.displayName;
export default TableFillerColumn;
//# sourceMappingURL=TableFillerColumn.js.map